














import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";

const StoryArchiveSorts = [
  { title: "Newest", sort: "CREATE_TIME,DESC;ID" },
  { title: "Tips", sort: "TIP_AMOUNT,DESC;ID" },
  { title: "Views", sort: "VIEW_COUNT,DESC;ID" },
  { title: "Likes", sort: "LIKE_COUNT,DESC;ID" },
];

export default defineComponent({
  name: "StoriesArchiveSort",
  components: { BaseButton },
  props: {
    selectedSort: { type: String, default: "CREATE_TIME,DESC;ID" },
  },
  setup(props, { emit }) {
    const storyArchiveSorts = StoryArchiveSorts;

    const handleSort = (sort: string) => {
      if (props.selectedSort !== sort) {
        emit("sort", sort);
      }
    };
    return {
      storyArchiveSorts,
      handleSort,
    };
  },
});
